import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const constantRoutes = [
  {
    path: "",
    component: () => import("@/layouts/full-page/FullPage.vue"),
    children: [
      {
        path: "/login",
        component: () => import("@/views/pages/Login.vue"),
      },
      {
        path: "/register",
        component: () => import("@/views/pages/Register.vue"),
      },
      {
        path: "/lastminute/:id",
        component: () => import("@/views/pages/LastMinute.vue"),
      },
    ],
  },
  {
    path: "",
    component: () => import("@/layouts/main/Admin.vue"),
    children: [
      {
        path: "/admin",
        component: () => import("@/views/pages/admin/AdminHome.vue"),
      },
      {
        path: "/admin-apis",
        component: () => import("@/views/pages/admin/APIs.vue"),
      },
      {
        path: "/admin-import",
        component: () => import("@/views/pages/admin/ImportHolidays.vue"),
      },
      {
        path: "/admin-calendar-sync",
        component: () => import("@/views/pages/admin/Dashboard.vue"),
      },
    ],
    meta: { requiresAuth: true, adminAuth: true },
  },
  {
    name: "booking",
    path: "/booking/:id",
    component: () => import("@/layouts/full-page/FullPage.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/pages/booking/Booking.vue"),
      },
    ],
  },
  {
    name: "booking-confirm",
    path: "/booking-confirm",
    component: () => import("@/layouts/full-page/FullPage.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/pages/booking/BookingConfirm.vue"),
      },
    ],
  },
  {
    path: "/business",
    component: () => import("@/layouts/main/Main.vue"),
    children: [
      {
        path: "/",
        name: "business",
        component: () => import("@/views/pages/business/Business.vue"),
      },
      {
        path: "/new-appointment",
        name: "new-appointment",
        component: () =>
          import("@/views/pages/appointments/NewAppointment.vue"),
      },
      {
        path: "/all-appointment",
        name: "all-appointment",
        component: () =>
          import("@/views/pages/appointments/AllAppointment.vue"),
      },
      {
        path: "/customers",
        name: "customers",
        component: () => import("@/views/pages/customers/Customers.vue"),
      },
      {
        path: "/events",
        name: "events",
        component: () => import("@/views/pages/events/Events.vue"),
      },
      {
        path: "/basic-rules",
        name: "basic-rules",
        component: () => import("@/views/pages/basicRules/BasicRules.vue"),
      },
      {
        path: "/logs",
        name: "logs",
        component: () => import("@/views/pages/logging/Logs.vue"),
      },
      {
        path: "/offers",
        name: "offers",
        component: () => import("@/views/pages/business/BusinessOffers.vue"),
      },
      {
        path: "/time",
        name: "time",
        component: () => import("@/views/pages/time/Time.vue"),
      },
      {
        path: "/settings",
        name: "settings",
        component: () => import("@/views/pages/business/BusinessSettings.vue"),
      },
    ],
  },
];

export default new Router({
  routes: constantRoutes,
  linkActiveClass: "is-active",
});



// WEBPACK FOOTER //
// ./src/router/index.js